<div *ngIf="isShown" class="sidebar-overlay">
</div>
<div *ngIf="isShown" class="sidebar-container overflow-hidden p-0">
    <div class="dark-section d-flex justify-content-between align-items-center py-5 px-4 mb-3">
        <h4>{{modalInputs.isInitialSign ? 'Sign Documents' : 'Resend Docs for Signing'}}</h4>
        <div>
            <button class="cp-failure-btn back-button uploadSignStyle_1" id="market-listing-modal-close"
                (click)="onSignUploadCancel(false)">X</button>
        </div>
    </div>
    <div class="px-6 upload-docs-scrollable">
        <div class="dark-section mx-4 mt-4 mb-5 px-4 pt-2 pb-5">
            <div class="m-4 fs-16 enabled-text">
                Add New Signatories to Docs
            </div>
            <div class="mx-4 mt-4">
                <ng-select id="repeat-signatories-for-docs" [items]="modalInputs.signatoriesList" class="icici-custom"
                    [multiple]="true" bindLabel="name" [hideSelected]="true" [(ngModel)]="repeatedSignatories"
                    placeholder="Search for Signatories to repeat across docs ... ">
                    <!--Template for selected label-->
                    <ng-template ng-label-tmp let-signatory="item">
                        <span class="ng-value-label">{{signatory.name}}
                            <small *ngIf="signatory.group_name" class="info-text font-style-normal">
                                ({{signatory.group_name}})</small>
                        </span>
                        <span aria-hidden="true" class="ng-value-icon right"
                            (click)="removeDocSignatory(signatory.id)">×</span>
                    </ng-template>
                    <!--Template for option in select dropdown-->
                    <ng-template ng-option-tmp let-signatory="item">
                        {{signatory.name}}
                        <small *ngIf="signatory.group_name" class="info-text font-style-normal">
                            ({{signatory.group_name}})</small>
                    </ng-template>
                </ng-select>
            </div>
        </div>
        <hr class="dashed-border-top mb-5 stretched-rule">
        <app-upload-sign-docs-form [modalInputs]="modalInputs" [container]="'sidepanel'"
            [commonSignatories]="repeatedSignatories" (formSubmitOrCancelEvent)="onSignUploadCancel($event)">
        </app-upload-sign-docs-form>
    </div>
</div>